import { useStorage } from "@vueuse/core";
export function useRoles() {
  return useStorage("roles", []);
}
export function usePermissions() {
  return useStorage("permissions", []);
}
